import uniq from "lodash/uniq";

function checkStdRouter(str, isBackend = false) {
  let result = { isRouter: false, url: str };
  if (typeof str != "string") {
    return result;
  }

  let exceptArr = [
    "/spa/cube/index.html#/main/cube/card",
    "/spa/workflow/index_form.jsp",
    "/spa/document/index.jsp"
  ];

  for (let index = 0; index < exceptArr.length; index++) {
    const element = exceptArr[index];
    if (str.indexOf(element) > -1) {
      return result;
    }
  }

  if (str.indexOf("index.html") > -1 && isBackend === true) {
    return result;
  }

  if (str.indexOf("engine.html") > -1 && isBackend === false) {
    return result;
  }

  const moduleConfigs = window.e9ModuleConfig;
  if (!moduleConfigs) {
    return result;
  }
  let modulePages = [];
  moduleConfigs.forEach(element => {
    if (element.page) {
      modulePages.push(element.page);
    }
  });
  modulePages = uniq(modulePages);

  modulePages.forEach(element => {
    if (str.indexOf(element) !== -1) {
      result.isRouter = true;
      result.url = str;
      if (str.indexOf("#") > -1) {
        result.url = str.slice(str.indexOf("#") + 1);
      }
      return result;
    }
  });

  let tempUrl = str;
  if (str.indexOf("?") > -1) {
    tempUrl = str.slice(0, str.indexOf("?"));
  }
  if (!/.*\.(html|jsp)/.test(tempUrl) && tempUrl.indexOf("/") === 0) {
    result.isRouter = true;
    result.url = str;
    return result;
  }

  return result;
}
module.exports = checkStdRouter;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/checkRouter.js